import { Component, Input } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { BoelsCategoryHierarchy } from '@boels/models';
import { CmsRouterLinkDirective } from '@boels/shared-state';

@Component({
  selector: 'boels-category-item',
  templateUrl: './category-item.component.html',
  styleUrls: ['./category-item.component.scss'],
  imports: [FontAwesomeModule, CmsRouterLinkDirective],
})
export class CategoryItemComponent {
  @Input() categoryItem: BoelsCategoryHierarchy;
  faArrowRight = faArrowRight;
}
